// src/pages/Home.jsx
import { Typography, Grid, Box } from "@mui/material";
import PageShell from "../shared/components/PageShell";
import TeamSection from "../shared/components/TeamSection";
import SouthEastIcon from "@mui/icons-material/SouthEast";
import HomeHeader from "../shared/components/HomeHeader";
import agcidChile from "../assets/agcidChile.svg";
import mexicoChile from "../assets/mexicoChile.svg";
import amexid from "../assets/AMEXID.svg";
import imgDesc from "../assets/photo_2026-03-13_18-08-27.jpg"
import LLGR from "../assets/Photos/LLGR2.png"
import ACT from "../assets/Photos/ACT.jpg"
import JM from "../assets/Photos/JM.png"
import M from "../assets/Photos/Dr_marcelo.png"
import Y from "../assets/Photos/Dra_yesenny.png"



const CONTENT_MAX = 1720;          // “ancho máximo” tipo YouTube
const CONTENT_GUTTER_X = { xs: 2, sm: 3, md: 4 }; // padding lateral fluido

export default function Home() {
    return (
        <>
            <HomeHeader id="home-page-title" />

            {/* HERO SECTION */}
            <PageShell id="#next-section">
                <Box
                    sx={{
                        width: "100%",
                        maxWidth: `${CONTENT_MAX}px`,
                        mx: "auto",
                        px: CONTENT_GUTTER_X,
                    }}
                >
                    <Grid
                        container
                        spacing={{ xs: 2, md: 4 }}
                        sx={{
                            alignItems: "center",
                            justifyContent: { xs: "center", md: "space-between" },
                        }}
                    >
                        {/* Izquierda: video/imagen */}

                        <Grid
                            size={{ xs: 12, md: 12, lg: 5 }}
                            sx={{
                                display: "flex",
                                justifyContent: { xs: "center", md: "center", lg: "flex-end" },
                            }}
                        >
                            <Box
                                sx={{
                                    width: "100%",
                                    maxWidth: { xs: 640, md: 760 },
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: 6,
                                    overflow: "hidden",
                                    backgroundColor: "#f5f5f5",
                                    border: '1px solid #d7d7d7'
                                }}
                            >
                                <Box
                                    component="img"
                                    src={imgDesc}
                                    sx={{
                                        maxWidth: "100%",
                                        maxHeight: "100%",
                                        objectFit: "contain",
                                    }}
                                />
                            </Box>
                        </Grid>
                        <Grid
                            size={{ xs: 12, md: 12, lg: 7 }}
                            sx={{
                                display: "flex",
                                justifyContent: { xs: "center", md: "center", lg: "flex-end" },
                            }}
                        >
                            <Box
                                sx={{
                                    width: "100%",
                                    maxWidth: { xs: "90%", md: "90%", lg: "100%" },
                                    textAlign: { xs: "center", md: "left" },
                                }}
                            >
                                <Typography
                                    variant="body1"

                                >
                                    Healthcare-associated infections represent an increasing challenge for health systems worldwide,
                                    as they contribute to higher mortality rates, prolonged hospital stays, and elevated healthcare costs.
                                    The emergence of multidrug-resistant bacteria, particularly Acinetobacter baumannii,
                                    Klebsiella pneumoniae, and Staphylococcus aureus—all members of the ESKAPE group—raises
                                    serious concern due to their capacity to acquire, accumulate, and disseminate resistance genes,
                                    thereby critically reducing the effectiveness of available antibiotics.
                                </Typography>

                                <Box sx={{ mt: 2 }}>
                                    <Typography
                                        variant="body1"
                                    >
                                        This portal presents the outcomes of a multinational research project whose primary objective is the
                                        comprehensive characterization of the genes and molecular mechanisms underlying antimicrobial resistance in these pathogens.
                                        Through whole-genome sequencing of clinical isolates collected in hospitals in Mexico and Chile, the project identifies
                                        key genetic determinants responsible for resistance. These findings enable the description of genetic diversity among
                                        isolates and provide insight into the molecular mechanisms driving the dissemination of resistance within hospital settings.
                                    </Typography>
                                </Box>

                                <Box sx={{ mt: 2 }}>
                                    <Typography
                                        variant="body1"
                                    >
                                        Furthermore, the portal supports the online submission of raw or processed sequencing data and the automated
                                        identification of resistance mechanisms. Summary statistics are incorporated into the project’s database,
                                        which also generates country-level reports on the distribution of resistance mechanisms identified.
                                    </Typography>
                                </Box>

                                <Box sx={{ mt: 2, display: "flex", justifyContent: { xs: "center", md: "flex-start" } }}>
                                    <Box sx={{ borderTop: "1px solid #20BC71", width: 125 }} />
                                </Box>

                                <Box sx={{ mt: 2 }}>
                                    <Typography variant="subtitle2">Citation</Typography>
                                    <Typography variant="caption text" fontStyle="italic" color="text.secondary" sx={{ mt: 1, textAlign: "justify" }}>
                                        If you use this resource, please use the following text:
                                    </Typography>
                                </Box>
                                <Box sx={{ mt: 1 }}>
                                    <Typography variant="caption text" fontStyle="italic" color="text.secondary" sx={{ mt: 1, textAlign: "justify" }}>
                                        This research used the Latin America Resistance Atlas generated by the project
                                        “Fortalecimiento de la vigilancia genómica de Acinetobacter baumannii en Latinoamérica
                                        a través del establecimiento de un eje de colaboración Chile-México"
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>



                        {/* Derecha: texto */}

                    </Grid>
                </Box>
            </PageShell >

            {/* TEAM */}
            < PageShell >
                <TeamSection title="Research team" members={team} />
            </PageShell >

            {/* FUNDING */}
            < PageShell >
                <Box
                    sx={{
                        width: "100%",
                        maxWidth: `${CONTENT_MAX}px`,
                        mx: "auto",
                        px: CONTENT_GUTTER_X,
                    }}
                >
                    <Grid
                        container
                        sx={{
                            width: "100%",
                            borderRadius: { xs: "30px", md: "60px" },
                        }}
                    >
                        <Grid size={{ xs: 12, lg: 5 }}>
                            <Box
                                sx={{
                                    textAlign: { xs: "center", md: "left" },
                                    display: "flex",
                                    flexDirection: "column",
                                    px: { xs: 2, sm: 4, md: 6, lg: 8 },
                                    height: "100%",
                                    justifyContent: "center",
                                    mb: { xs: 4, md: 0 },
                                    p: 10
                                }}
                            >
                                <Typography variant="h3" sx={{ m: 0, mb: 1 }}>
                                    Funding
                                </Typography>
                                <Typography color="text.secondary" variant="body1" sx={{ mb: 1 }}>
                                    Este sitio web es producto del proyecto "Fortalecimiento de la vigilancia genómica de <i>Acinetobacter baumannii</i>
                                    en Latinoamérica a través del establecimiento de un eje de colaboración Chile-México" entre el Instituto Nacional
                                    de Medicina Genómica, el Hospital Juárez de México y la Universidad Santiago de Chile, financiado por el Fondo
                                    Conjunto de Cooperación México-Chile entre los años 2023 y 2026.
                                </Typography>
                                <Typography color="text.secondary" variant="body1">
                                    This website is the product of the project "Strengthening the genomic surveillance of <i>Acinetobacter baumannii</i> in
                                    Latin America through the establishment of a Chile-Mexico collaboration axis" between the National Institute of
                                    Genomic Medicine, the Hospital Juárez de México, and the University of Santiago de Chile, funded by the Joint
                                    Mexico-Chile Cooperation Fund between 2023 and 2026.
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, lg: 7 }} sx={{ display: "flex", justifyContent: "center" }}>
                            <Box sx={{
                                width: "100%",
                                height: '100%',
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                alignContent: "center",
                                flexDirection: "column",
                            }}>
                                <Box
                                    sx={{
                                        width: "100%",
                                        height: { xs: '100%', lg: '80%' },
                                        maxWidth: 995,
                                        border: "1px solid #20BC71",
                                        borderRadius: 6,
                                        py: { xs: 4, md: 2 },
                                        px: { xs: 2, md: 4 },
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <Grid
                                        container
                                        spacing={{ xs: 4, md:6, lg: 2 }}
                                        sx={{
                                            width: "100%",
                                            justifyContent: { xs: "center", md: "space-between" },
                                            alignItems: "center",
                                        }}
                                    >
                                        <Grid size={{ xs: 12, lg: 4 }}>
                                            <Box
                                                component="img"
                                                src={agcidChile}
                                                alt="AGCID Chile"
                                                sx={{
                                                    width: "100%",
                                                    maxWidth: { xs: 160, sm: 180, md: 200, lg: 218 },
                                                    height: "auto",
                                                    mx: "auto",
                                                    display: "block",
                                                }}
                                            />
                                        </Grid>

                                        <Grid size={{ xs: 12, lg: 4 }}>
                                            <Box
                                                component="img"
                                                src={mexicoChile}
                                                alt="México-Chile"
                                                sx={{
                                                    width: "100%",
                                                    maxWidth: { xs: 140, sm: 160, md: 180, lg: 186 },
                                                    height: "auto",
                                                    mx: "auto",
                                                    display: "block",
                                                }}
                                            />
                                        </Grid>

                                        <Grid size={{ xs: 12, lg: 4 }}>
                                            <Box
                                                component="img"
                                                src={amexid}
                                                alt="AMEXCID"
                                                sx={{
                                                    width: "100%",
                                                    maxWidth: { xs: 180, sm: 200, md: 220, lg: 229 },
                                                    height: "auto",
                                                    mx: "auto",
                                                    display: "block",
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </PageShell >

            {/* CONTACT */}
            < PageShell >
                <Box
                    sx={{
                        width: "100%",
                        maxWidth: `${CONTENT_MAX}px`,
                        mx: "auto",
                        px: CONTENT_GUTTER_X,
                    }}
                >
                    <Grid
                        container
                        sx={{
                            background: "#000",
                            width: "100%",
                            borderRadius: 6,
                            p: 10
                        }}
                    >
                        <Grid
                            size={{ xs: 12, md: 6 }}
                            sx={{
                                px: { xs: 2, sm: 4, md: 6, lg: 8 },
                                textAlign: { xs: "center", md: "left" },
                                mb: { xs: 4, md: 0 },
                            }}
                        >
                            <Typography variant="h3" sx={{ color: "#fff" }}>
                                Contact
                            </Typography>
                        </Grid>

                        <Grid
                            size={{ xs: 12, md: 6 }}
                            sx={{
                                display: "flex",
                                justifyContent: { xs: "center", md: "flex-start" },
                                px: { xs: 2, md: 0 },
                            }}
                        >
                            <Box>
                                <Box sx={{ display: "flex", flexDirection: "row", mb: 4, alignItems: "flex-start" }}>
                                    <SouthEastIcon color="green" sx={{ width: 35, height: 35, flexShrink: 0 }} />
                                    <Typography variant="body1" sx={{ color: "#fff", mt: 0.5, ml: 2, textAlign: "left" }}>
                                        If you have any questions about the project, please contact
                                        <br />
                                        acedro@inmegen.gob.mx
                                    </Typography>
                                </Box>

                                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "flex-start" }}>
                                    <SouthEastIcon color="green" sx={{ width: 35, height: 35, flexShrink: 0 }} />
                                    <Typography variant="body1" sx={{ color: "#fff", mt: 0.5, ml: 2, textAlign: "left" }}>
                                        If you have any questions about the platform, please contact
                                        <br />
                                        lgomez@inmegen.gob.mx
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </PageShell >
        </>
    );
}

const team = [
    {
        id: 1, name: "Dra Laura Gómez-Romero", org: "INMEGEN", photoUrl: LLGR, profileUrl: "#", data: `
        Dr. Laura Gómez-Romero holds a Bachelor’s degree in Genomic Sciences and a PhD in Biomedical Sciences from the National Autonomous University of Mexico (UNAM). She is currently the Deputy Director of Bioinformatics at the National Institute of Genomic Medicine (INMEGEN). Dr. Gómez’s research has focused on understanding the genomic foundations of health and disease. Her main research lines are centered on cancer prevention and diagnosis through artificial intelligence algorithms and multi-omics data analysis, as well as the genomic surveillance of emerging pathogens such as SARS-CoV-2 and Acinetobacter baumannii.
Dr. Gómez is part of several multidisciplinary teams, where she considers bioinformatics and computational biology as fundamental pillars for producing research with a high social impact.

        ` },
    {
        id: 2, name: "Dr. Yesseny Vásquez Martínez", org: "USACH", photoUrl: Y, profileUrl: "#", data: `
        Dr. Yesseny Vásquez Martínez is an Associate Professor at the School of Medicine of the University of Santiago de Chile and a researcher at the Molecular Virology and Pathogen Control Laboratory. She earned her degree in Chemistry and her Ph.D. in Chemistry from the University of Santiago de Chile. During her academic training she conducted research stays at the Kekulé Institute for Organic Chemistry at the University of Bonn (Germany) and at the Department of Chemistry and Biochemistry of the University of California, Santa Cruz (USA).
Prior to joining academia, she worked for seven years as a project leader at the Chemical Metrology Center for Water and Food at Fundación Chile. During this period she collaborated with international institutions including Wageningen University and Research, the Laboratory of the Government Chemist in the United Kingdom, and the National Institute of Standards and Technology in the United States. Her research focuses on antimicrobial resistance, molecular detection of pathogens, genomic surveillance of emerging infectious diseases, and the identification of inhibitors of inflammatory enzymes. She currently leads nationally funded research projects and participates in graduate education within the Public Health Master’s Program and the Doctoral Program in Biotechnology at USACH.

        `},
    {
        id: 3, name: "Dr. Alberto Cedro Tanda", org: "INMEGEN", photoUrl: ACT, profileUrl: "#", data: `
        Dr. Alberto Cedro Tanda is a scientist specializing in precision oncology and genomics. He trained at UNAM, earning a B.S. in Biology with honors, an M.S., and a Ph.D. in Biomedical Sciences with distinction. Since 2020, he has served as a “C” Medical Sciences Researcher in the Precision Medicine Innovation Unit (Core B) at INMEGEN and is a Level I member of Mexico’s National System of Researchers (SNII). His research focuses on developing molecular tests to support the clinical management of patients with gastrointestinal cancers and breast cancer, as well as on genomic surveillance through sequencing.
Since the start of the COVID-19 pandemic, he has led SARS-CoV-2 genomic surveillance (one of the programs with the highest number of viral genomes sequenced in Mexico) and coordinates a similar effort for Mpox virus. He also contributes to whole-genome sequencing (WGS) surveillance of multidrug-resistant bacteria, supporting the detection, characterization, and tracking of lineages and resistance mechanisms. He is an active member of the Spanish Scientists in Mexico Network (RECEMX), has led nationally and internationally funded projects, and collaborates with Mexico’s national network of health institutes (INCMNSZ, INCAN, INCICH). His academic output includes 28 articles in leading international journals, 458 citations, and an h-index of 14.

        ` },
    {
        id: 4, name: "Dr. Marcelo Cortez-San Martín", org: "USACH", photoUrl: M, profileUrl: "#", data: `
        Dr. Marcelo Cortez-San Martín is a Professor in the Department of Biology at the Faculty of Chemistry and Biology of the University of Santiago de Chile (USACH), where he leads the Molecular Virology and Pathogen Control Laboratory and currently serves as Director of the Doctoral Program in Biotechnology. He obtained his B.Sc. in Biochemistry from USACH and his Ph.D. in Biochemistry and Molecular Biology from the University of Santiago de Compostela, Spain. During his academic training he studied the molecular biology of animal viruses, including infectious pancreatic necrosis virus and avian reovirus.
Before joining academia, Dr. Cortez worked in the veterinary pharmaceutical industry as Head of Research and Development in avian and swine health, where he contributed to the development of vaccines and antimicrobial alternatives targeting pathogens such as Salmonella enteritidis, Lawsonia intracellularis, Mycoplasma hyopneumoniae, porcine circovirus type 2, and porcine parvovirus. His current research focuses on the molecular study of animal viruses, antiviral discovery, and vaccine development for pathogens relevant to aquaculture and animal production, including ISAV, IPNV, PRV, and SARS-CoV-2. He has led multiple nationally funded research projects and supervised numerous graduate theses in biotechnology, microbiology, and aquaculture.
        `},
    {
        id: 5, name: "Dr. Juan Manuel Bello López", org: "HJM", photoUrl: JM, profileUrl: "#", data: `
        Dr. Juan Manuel Bello López is a medical sciences researcher specializing in antimicrobial resistance, clinical microbiology, and hospital infection control. He obtained his B.S. in Clinical Microbiology (Químico Bacteriólogo Parasitólogo), as well as his M.S. and Ph.D. in Chemical-Biological Sciences from the Escuela Nacional de Ciencias Biológicas at the Instituto Politécnico Nacional (IPN). He later completed a postdoctoral fellowship at CINVESTAV-IPN in Biotechnology and Bioengineering, where he expanded his research into metagenomics and antimicrobial resistance in medically important pathogens.
Since 2013, he has served as a full-time Medical Sciences Researcher at the Hospital Juárez de México within the Mexican Ministry of Health and is currently a Level II member of Mexico’s National System of Researchers (SNII). His academic output includes more than 100 peer-reviewed publications in international journals.
His research focuses on the molecular and genetic mechanisms involved in antibiotic resistance among clinically relevant pathogens. He has also developed research lines exploring non-antibiotic strategies for pathogen control, including disinfection technologies and approaches targeting biofilm-forming microorganisms.
Dr. Bello López has supervised undergraduate, master’s, and doctoral theses on antimicrobial resistance and clinical microbiology and currently teaches in the Master’s Program in Health Sciences at the Escuela Superior de Medicina. His work aims to advance the understanding of multidrug resistance and support strategies to prevent the spread of clinically relevant pathogens.

        ` },
];